import { cn } from "@/lib/utils";

export const StatCard = ({ icon: Icon, label, value, sub, testId, accent = false }) => {
  return (
    <div
      className="rounded-[var(--radius)] border bg-card p-4 sm:p-5 shadow-[0_1px_0_rgba(0,0,0,0.04)] flex items-start justify-between gap-3"
      data-testid={testId}
    >
      <div className="space-y-1 min-w-0">
        <p className="text-xs sm:text-sm text-muted-foreground font-medium truncate">{label}</p>
        <p className="text-2xl md:text-3xl font-semibold tabular-nums font-heading">{value}</p>
        {sub && <p className="text-xs text-muted-foreground">{sub}</p>}
      </div>
      {Icon && (
        <div
          className={cn(
            "shrink-0 h-10 w-10 rounded-full flex items-center justify-center",
            accent ? "bg-[hsl(var(--role-accent))] text-white" : "bg-secondary text-secondary-foreground"
          )}
        >
          <Icon className="h-5 w-5" />
        </div>
      )}
    </div>
  );
};
